module.exports = __webpack_public_path__ + "28690bbdf82cddbfd80dd6a276f78a94.pdf";